export default "__VITE_ASSET__C9pO69uq__"